export const getStyles = () => ({
  counterContainer: {
    overflow: "hidden",
    backgroundColor: "#E1E1FF"
  },

  counterSection: {
    position: "relative",

    "& h2": {
      textAlign: "center",
      fontSize: "1.25rem",
      fontWeight: 700,
      marginBlock: "24px",
    },

    "@media (min-width: 960px)": {
      minHeight: "700px",
      gridColumn: "2 / -2",
      display: "grid",
      gridTemplateColumns: "auto 1fr",
      columnGap: "24px",

      "& h2": {
        gridColumn: "1 / -1",
        fontSize: "2.5rem",
        marginBlock: "80px",
      },
    },
  },
  counterStats: {
    width: "calc(75% - 20px)",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "20px",

    zIndex: 2,
    marginBottom: "-48px",

    "@media (min-width: 960px)": {
      width: "100%",
      marginBottom: "80px",
      flexDirection: "column",
      gap: "64px",
      paddingRight: "40px",
    },
  },
  counterStatItem: {
    textAlign: "center",
    "& h4": {
      fontSize: "1.25rem",
      fontWeight: 700,
    },
    "& p": {
      fontSize: "0.875rem",
    },

    "@media (min-width: 960px)": {
      "& h4": {
        fontSize: "3.75rem",
      },
      "& p": {
        fontSize: "1.5rem",
      },
    },
  },
  counterImages: {
    justifySelf: "flex-end",
    display: "flex",
    alignItems: "flex-end",
    minWidth: 0,
    marginLeft: "60px",

    "& > *": {
      display: "flex",
      minWidth: 0,
      width: "25%",
    },
    "& img": {
      height: "auto",
      width: "100%",
      objectFit: "contain",
    },

    "@media (min-width: 960px)": {
      marginLeft: "0",
    },
  },

  disabledImage: {
    filter: "grayscale(100%)",
  },
});
